<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="row otherWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/participation/p-icon1.png"/><span>展厅平面图</span>
          </div>
          <div class="page-tab-wrap">
            <div class="page-tab">
              <span :class="{'active' : tabIndex === tIdx}" v-for="(tItem,tIdx) in tabList" :key="tIdx" @click="tabIndex = tIdx">{{tItem}}</span>
            </div>
          </div>
          <div class="page-pic" v-show="tabIndex < 2? (idx == tabIndex):(idx-1 == tabIndex)" v-viewer="options" v-for="(item, idx) in imgList" :key="idx">
            <img :src="globalVar.imgUrl+item.attendGuideHallInfo.imageUrl"/>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/participation/p-icon2.png"/><span>大会信息</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in info" :key="idx" @click="infoHandle(item)"><v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp></p>
          </div>
          <div class="page-header-news clearfix" style="margin-top: 0%;">
            <img class="icon1" src="../../static/images/participation/p-icon5.png"/><span>我要参会</span>
          </div>
          <div class="row page-list page-enter">
            <div class="col-xs-6 col-sm-3 col-md-3">
              <img src="../../static/images/participation/1.png"/>
              <router-link :to="{name: 'PdfPPage', query: {name: '邀请函'}}" class="link">参会邀请函</router-link>
            </div>
            <div class="col-xs-6 col-sm-3 col-md-3">
              <img src="../../static/images/participation/2.png"/>
              <router-link :to="{ name: 'TicketPage', query: { name: '票证办理程序' }}" class="link">注册/登录<br/>客商自助服务中心<br/>办理票证</router-link>
            </div>
            <div class="col-xs-6 col-sm-3 col-md-3">
              <img src="../../static/images/participation/3.png"/>
              <router-link :to="{name: 'noticeP',query: {name: '报到须知'}}" class="link">报到须知</router-link>
            </div>
            <div class="col-xs-6 col-sm-3 col-md-3">
              <img src="../../static/images/participation/4.png"/>
              <router-link :to="{name: 'planPage', query: {name: '展馆规划'}}" class="link">参观展馆</router-link>
              <router-link :to="{name: 'SeminarPage', query: {name: '系列研讨会'}}" class="link">参加论坛研讨会</router-link>
              <router-link :to="{name: 'Project'}" class="link">参加项目对接</router-link>
            </div>
          </div>
          <div class="page-header-news clearfix" style="margin-top: 0%;">
            <img class="icon1" src="../../static/images/participation/p-icon3.png"/><span>大会服务</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in join" :key="idx" @click="infoHandle(item)"><v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp></p>
          </div>
          
        </div>
      </div>
    </div>
    <!-- 3D展厅 -->
    <div class="row adPicWrap" style="margin-bottom:10px">
      <div class="container" >
        <img src="../../static/images/3D/3DBG.png" alt="" srcset="" style="cursor:pointer;max-width:100%" @click="$router.push({name:'3D展厅'})">
      </div>
    </div>

    <div class="row latesWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6 page-ad" v-for="(item,idx) in adPicWrap" :key="idx" v-show="item.state != -1" @click="topic(item)">
          <img v-if="item.state === 1" :src="globalVar.imgUrl+item.imgurl"/>
          <img v-if="item.state === 0" :src="globalVar.imgUrl+item.imgurl"/>
        </div>
      </div>
    </div>
    
    <div class="row four-enterWrap">
      <div class="container page-three-enter">
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'pdfP', query: { name: '大会指南'}}"><img src="../../static/images/participation/enter1.png" alt="大会指南"/></router-link></div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'pdfP', query: { name: '推介书'}}"><img src="../../static/images/participation/enter2.png" alt="推介书"/></router-link></div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'pdfP', query: { name: '组委会各工作结构'}}"><img src="../../static/images/participation/enter3.png" alt="组委会各办公驻地及电话"/></router-link></div>
      </div>
  </div>
  <div class="row exhWrap">
    <div class="container">
      <div class="col-xs-12">
        <div class="page-header-news clearfix">
          <img class="icon1" src="../../static/images/participation/p-icon4.png"/><span>参会问答</span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 noPadding page-exh-list">
          <div class="col-xs-12 col-sm-6 col-md-6" v-for="(item, idx) in faqList" :key="idx">
            <div class="answer">
              <h3>{{item.problemName}}</h3>
              <p v-html="item.contents"></p>
            </div>
          </div>
        </div>
      </div>
      </div>
  </div>
</div>
</template>

<script>
import subMenuBar from '@/components/subMenuBar/subMenuBar'
import VClamp from 'vue-clamp'
export default {
  components: {
    subMenuBar,
    VClamp,
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.participation,
      options: {
        "navbar": false,
        "title": false,
        "toolbar": false,
        "transition": false,
        "keyboard": false
      },
      // tabList: ["展厅平面图","会展平面图","行车路线图","交通接驳车","厦门市地图"],
      tabList: ["展厅平面图","会展平面图","交通接驳车","厦门市地图"],
      tabIndex: 0,
      info: [
        {
          title: '大会主要活动',
          pathName: 'ActPage',
          name: '活动预览表'
        },{
          title: '展区设置',
          pathName: 'planPage',
          name: '展馆规划'
        },{
          title: '参展商名单',
          pathName: 'SearchPage',
          name: '展商信息'
        },{
          title: '论坛研讨会安排',
          pathName: 'SeminarPage',
          name: '系列研讨会'
        },{
          title: '项目对接会安排',
          pathName: 'pdfProPage',
          name: '项目对接会安排'
        },{
          title: '客商团组',
          pathName: 'pdfP',
          name: '客商团组'
        },{
          title: '证件管理办法',
          pathName: 'docPage',
          name: '证件管理办法'
        },{
          title: '联络组委会各工作机构',
          pathName: 'contactP',
          name: '联络组委会各工作机构'
        }
      ],
      join: [
        {
          title: '酒店预订',
          pathName: 'Hotel',
          name: '找酒店'
        },{
          title: '翻译服务',
          pathName: 'translateP',
          name: 4
        },{
          title: '信息服务',
          pathName: 'translateP',
          name: 8
        },{
          title: '城际交通',
          pathName: 'translateP',
          name: 2
        },{
          title: '市内交通',
          pathName: 'translateP',
          name: 5
        },{
          title: '展馆接驳车',
          pathName: 'translateP',
          name: 9
        },{
          title: '展馆停车',
          pathName: 'picP',
          name: '展馆停车',
        },{
          title: '展馆餐饮',
          pathName: 'translateP',
          name: 6
        },{
          title: '医疗服务',
          pathName: 'translateP',
          name: 10
        },{
          title: '参会咨询',
          pathName: 'translateP',
          name: 3
        },{
          title: '展馆商务服务',
          pathName: 'translateP',
          name: 7
        }
      ],
      SelfServicelogin: this.globalVar.SelfServicelogin,
      adPicWrap: Array,
      imgList: Array,
    }
  },
  async created(){
    await this.init();
    !this.faqList.length ? this.faq() : '';
  },
  computed:{
    faqList(){
      return this.$store.state.participation.faq
    }
  },
  methods: {
    subpagemenu(item){
      if(item.subName === "在线报名"){
          window.location.href = this.globalVar.SelfServicelogin;
      }else{
        this.$router.push({
          name: item.pathName,
          query: {
            name: item.subName,
          }
        })
      }
    },
    infoHandle(item){
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.name,
          title: item.title
        }
      })
    },
    async init(){
      this.adPicWrap = await this.findAd();//获取广告信息
      this.imgList = await this.getList();//展厅平面图
    },
    findAd(){
      let params = {
          code: 'C',
          language: this.globalVar.lang
      }
      return this.$store.dispatch("findAd", params);
    },
    getList(){
      let params = {
          language: this.globalVar.lang,
          sessionName: '',
          type: ''
      }
      return this.$store.dispatch("getimgList", params);
    },
    async topic(item){
      let params = {
        id : item.id
      }
      let data = await this.$store.dispatch("clicks", params);
      if(data.isguest === 1){
        this.$router.push({
            path: '/topic',
            query: {
                gid : data.gid
            }
        })
      }else{
        window.location.href=data.url
      }
    },
    async faq(){
      let params = {
        language: this.globalVar.lang
      }
      return await this.$store.dispatch("faq", params);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
@import '../../static/function.less';
.otherWrap{
  margin-bottom: 1%;
  .page-header-news{
    margin-top: 3%;
  }
  .page-tab-wrap{
    margin-top: 3%;
  }
  .page-pic{
    margin-top: 4%;
    text-align: center;
    cursor: pointer;
    height: 500px;
  }
  .page-list{
    margin-top: 3%;
    padding: 0 3%;
    cursor: pointer;
    p{
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover{
        .hoverTxtColor()
      }
      &:before{
        content:''; 
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
    .link{
      display: block;
      font-size: @font14;
      padding: 5px 0px;
      &:hover{
        .hoverTxtColor();
      }
    }
  }
}
.latesWrap{
  .page-ad{
    padding: 1% 15px;
  }
}
.exhWrap{
  margin-bottom: 50px;
  .page-exh-list{
    .flexitems(flex-start);
    .answer{
      margin-top: 20px; 
      padding-left: 20px;
      position: relative;
      &::before{
        content: '';
        position: absolute;
        left: 0;
        background: url('../../static/images/participation/problemBg.png') no-repeat center;
        width: 16px;
        height: 16px;
        display: inline-block;
        background-size: cover;
      }
    }
    h3{
      font-size: @font16;
      color: #333;
      font-weight: bold;
    }
    p{
      font-size: @font14;
      margin: 10px 0px;
      a{
        color: #2d9bf0;
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
}
.four-enterWrap{
  width: 100%;
  margin: 2% 0px;
  font-size: 20px;
  color: #303133;
  font-weight: bold;
  padding: 3%;
  background: url('../../static/images/index/adBg.png') no-repeat center;
  background-size: cover;
  .page-three-enter{
    width: 1000px;
  }
  .page-four-enter{
    padding: 1%;
    cursor: pointer;
    text-align: center;
    a{
      display: inline-block;
    }
    &:hover{
      img{
          .shadow(4px)
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 767px){
  .slideMenu{
    display: block;
  }
  .four-enterWrap .page-three-enter{
    width: 100%;
  }
  .otherWrap .page-tab span{
    display: inline-block;
    -webkit-box-flex: unset;
    -moz-box-flex: unset;
    -webkit-flex: unset;
    -ms-flex: unset;
    flex: unset;
  }
  .page-enter{
    text-align: center;
  }
  .otherWrap .page-pic{
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Participation.vue